import { ArchiveComponent } from './archive/archive.component';
import { AuthAutomaticComponent } from './auth/auth-automatic/auth-automatic.component';
import { AuthAutomaticCodeComponent } from './auth/auth-automatic/auth-automatic-code.component';
import { AuthScreenComponent } from './auth/auth-screen/auth-screen.component';
import { LogoutComponent } from './auth/logout.component';
import { CallbackComponent } from './callback/callback.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { EgpComponent } from './egp/egp.component';
import { VerificationComponent } from './egp/verification/verification.component';
import { EppComponent } from './epp/epp.component';
import { EpsComponent } from './eps/eps.component';
import { ErpComponent } from './erp/erp.component';
import { HomeComponent } from './home/home.component';
import { LogbookComponent } from './logbook/logbook.component';
import { M6Component } from './m6/m6.component';
import { MarwisComponent } from './marwis/marwis.component';
import { ModelComponent } from './model/model.component';
import { OperationalReportEditComponent } from './operation-report/operational-report.edit.component';
import { OperationalReportListComponent } from './operation-report/operational-report.list.component';
import { PigeonsComponent } from './pigeons/pigeons.component';
import { RadarComponent } from './radar/radar.component';
import { RouteFcstComponent } from './route-fcst/route-fcst.component';
import { SatComponent } from './sat/sat.component';
import { SmwComponent } from './smw/smw.component';
import { StyleguideComponent } from './styleguide/styleguide.component';
import { TrendComponent } from './trend/trend.component';
import { UserAdminComponent } from './user/user-admin.component';
import { WarningComponent } from './warning/warning.component';
import { WarningCurrentComponent } from './warning/warning-current.component';
import { WarningTimelineComponent } from './warning/warning-timeline.component';

import { authGuard } from './auth/auth.guard';

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const appRoutes: Routes = [
  {
    path: 'home',
    component: HomeComponent,
  },
  {
    path: 'login',
    component: AuthScreenComponent,
  },
  {
    path: 'bamberg-login',
    component: AuthAutomaticComponent,
  },
  {
    path: 'automatic-login',
    component: AuthAutomaticCodeComponent,
  },
  {
    path: 'logout',
    component: LogoutComponent,
  },
  {
    path: 'callback',
    component: CallbackComponent,
  },
  {
    path: 'customer-data',
    component: UserAdminComponent,
    canActivate: [authGuard],
  },
  {
    path: 'warning',
    component: WarningComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'current',
        pathMatch: 'full',
      },
      {
        path: 'current',
        component: WarningCurrentComponent,
      },
      {
        path: 'timeline',
        component: WarningTimelineComponent,
      },
      {
        path: 'timeline/:region',
        component: WarningTimelineComponent,
      },
    ],
  },
  {
    path: 'eps',
    component: EpsComponent,
    canActivate: [authGuard],
  },
  {
    path: 'eps/:station',
    component: EpsComponent,
    canActivate: [authGuard],
  },
  {
    path: 'egp',
    component: EgpComponent,
    canActivate: [authGuard],
  },
  {
    path: 'egp/:region',
    component: EgpComponent,
    canActivate: [authGuard],
  },
  {
    path: 'verification',
    component: VerificationComponent,
    canActivate: [authGuard],
  },
  {
    path: 'epp',
    component: EppComponent,
    canActivate: [authGuard],
  },
  {
    path: 'epp/:station',
    component: EppComponent,
    canActivate: [authGuard],
  },
  {
    path: 'pigeons',
    component: PigeonsComponent,
    canActivate: [authGuard],
  },
  {
    path: 'erp',
    component: ErpComponent,
    canActivate: [authGuard],
  },
  {
    path: 'smw',
    component: SmwComponent,
    canActivate: [authGuard],
  },
  {
    path: 'smw/:station',
    component: SmwComponent,
    canActivate: [authGuard],
  },
  {
    path: 'radar',
    component: RadarComponent,
    canActivate: [authGuard],
  },
  {
    path: 'radar/:region/:zoom',
    component: RadarComponent,
    canActivate: [authGuard],
  },
  {
    path: 'sat',
    component: SatComponent,
    canActivate: [authGuard],
  },
  {
    path: 'model',
    component: ModelComponent,
    canActivate: [authGuard],
  },
  {
    path: 'm6',
    component: M6Component,
    canActivate: [authGuard],
  },
  {
    path: 'marwis',
    component: MarwisComponent,
    canActivate: [authGuard],
  },
  {
    path: 'route-fcst',
    component: RouteFcstComponent,
    canActivate: [authGuard],
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [authGuard],
  },
  {
    path: 'archive',
    component: ArchiveComponent,
    canActivate: [authGuard],
  },
  {
    path: 'logbook',
    component: LogbookComponent,
    canActivate: [authGuard],
  },
  {
    path: 'operation-report',
    component: OperationalReportListComponent,
    canActivate: [authGuard],
  },
  {
    path: 'operation-report-edit',
    component: OperationalReportEditComponent,
    canActivate: [authGuard],
  },
  {
    path: 'styleguide',
    component: StyleguideComponent,
    /*canActivate: [authGuard],*/
  },
  {
    path: 'trend',
    component: TrendComponent,
    canActivate: [authGuard],
  },
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '/home',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
